import { FormInputErrorEnum } from '../interfaces/FormInput';


export function getErrorText(error: FormInputErrorEnum): (string | null) {
    let text: string | null;
    switch(error) {
        case FormInputErrorEnum.RequiredField: 
            text="Поле должно быть заполнено"; 
            break;
        case FormInputErrorEnum.ValidationError: 
            text="Указанно что-то нето"; 
            break;

        default: throw new Error("Must be on of FormInputErrorEnum");
    }
    return text
}